import { Box } from "@mui/material";
import Colors from "@constants/Colors";
import styled from "styled-components";

export const StyledContainer = styled(Box)`
  @media (max-width: 1000px) {
    min-width: 266px !important;
    min-height: calc(100% - 44px);
  }
  @media (min-width: 1000px) {
    background-color: ${Colors.white};
    min-height: calc(100vh - 105px);
    position: fixed;
    min-width: 22% !important;
  }
  padding: 24px 16px 0 !important;
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
  min-width: 22% !important;
`;
